import { Component, OnInit } from '@angular/core';
import { constants } from './../../shared/common/contants';
import { LocalStorageSettingsService } from './../../shared/services/local-storage-settings.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Radiobutton } from 'src/app/shared/common/Radiobutton';
import { EtlService } from '../vault-data-migration-etl/etl.service';


@Component({
    selector: 'app-etllibraryobjects',
    templateUrl: './etllibraryobjects.component.html',
    styleUrls: ['./etllibraryobjects.component.scss'],
    standalone: false
})
export class EtllibraryobjectsComponent implements OnInit {

  columnDefsForObjects;
  rowData;
  rowSelectionForTablesFields;
  rowSelection;
  backgroundColorScreen="";
  buttonColor="";
  allocateButtonsBoolean = false;
  allocateButtons1Boolean = false;
  backgroundColorButton = "";
  vaultObjects:any;
  gridApi;
  defaultColDef;
  components: any;
  selectedVaultObjects:any = [];
  libraryobjectData:any = [];
  objectDetails:any =[];
  objectDataValidation;
  vaultObjectData;
  temp:any=[];

  constructor(private dialogref: MatDialogRef<EtllibraryobjectsComponent>, private constants: constants, private localStorageSettings: LocalStorageSettingsService, private service:EtlService, private snackbar: MatSnackBar, private spinner: NgxUiLoaderService) {
    this.components = {
      buttonRenderer: Radiobutton
    }
   }

  ngOnInit() {

    this.columnDefsForObjects = [{
      headerName: 'Select', filter: false,
      // headerCheckboxSelection: true,
      // headerCheckboxSelectionFilteredOnly: true,
      checkboxSelection: true,
      // cellRenderer: 'buttonRenderer',
      field:'selection',
       width: 100
    },
    {
      headerName: "Object Name",
      headerTooltip: "Object Name",
      tooltipValueGetter: params => "Object Name : " + params.value,
      field: "objectName",
      filter: "agTextColumnFilter",
      width: 300,
      headerClass: 'headerClassName',
      // headerCheckboxSelectionFilteredOnly: true,
      // checkboxSelection: true,
      cellStyle: { " padding-left": "5px" }
    },
    {
      headerName: "Last Modified",
      headerTooltip: "Last Modified",
      tooltipValueGetter: params => "Last Modified : " + params.value,
      field: "lastModified",
      filter: "agTextColumnFilter",
      width: 200,
      headerClass: 'headerClassName',
      // headerCheckboxSelectionFilteredOnly: true,
      // checkboxSelection: true,
      cellStyle: { " padding-left": "5px" }
    }
    ];
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelectionForTablesFields='multiple';
    this.rowSelection = this.constants.rowselection;
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);
  }

  async onGridReadyForObjects(params){
    this.vaultObjects= params;
    this.gridApi= params.api;
    this.objectDetails=[];
    this.gridApi.setGridOption('rowData', [])
    this.spinner.start();
    this.service.retrieveVaultObjects().subscribe((val) => {
      console.log(val)
      this.objectDetails = val;
      if(this.objectDetails.length ===0){
        this.gridApi.setGridOption('rowData', [])
        this.spinner.stop();
      }else{
         console.log(this.objectDetails)
         this.gridApi.setGridOption('rowData', this.objectDetails);
         this.spinner.stop();
      }
    });
  }

  onRowSelected(event){
    this.selectedVaultObjects=[]
    this.temp=[];
    this.libraryobjectData=[];
    this.libraryobjectData = this.gridApi.getSelectedRows();
    console.log(this.libraryobjectData);    
    // For single/multiple object re-extraction
    for(let i=0; i<this.libraryobjectData.length; i++){
      console.log(this.libraryobjectData[i].objectName);
      this.selectedVaultObjects.push(this.libraryobjectData[i].objectName);
      // this.selectedVaultObjects = this.libraryobjectData[i].objectName;
      console.log(this.selectedVaultObjects);
    }
  }

  reextract(){   
    let dnsName = this.localStorageSettings.getSettings("vaultDnsname");
    console.log(dnsName);
    console.log(this.selectedVaultObjects);
      if(this.selectedVaultObjects.length === 0){
        this.snackbar.open("Please select Object to Re-Extract", "OK");
      }
      else{        
        this.spinner.start();
        this.service.reExtractLibraryObject(dnsName,this.selectedVaultObjects).subscribe(response =>{
          console.log(response);
          if (response.error == true) {
            this.spinner.stop();
            this.snackbar.open(response.statusMessage, "OK", {
              duration: 5000,
            });
          }
          else{
            this.spinner.stop();
            this.snackbar.open(response.statusMessage, "OK", {
              duration: 5000,
            });
            this.cancel();
          }
        })
      }    
  }

  cancel() {
    this.selectedVaultObjects=[];
     this.dialogref.close();
    }

}
